import { render } from "./CorrectTwoView.vue?vue&type=template&id=1bbc9516&ts=true"
import script from "./CorrectTwoView.vue?vue&type=script&lang=ts"
export * from "./CorrectTwoView.vue?vue&type=script&lang=ts"

import "./CorrectTwoView.vue?vue&type=style&index=0&id=1bbc9516&lang=scss"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__